import { render, staticRenderFns } from "./cardFaq.vue?vue&type=template&id=6f9e902a"
import script from "./cardFaq.vue?vue&type=script&lang=js"
export * from "./cardFaq.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports